
// config/envUtils.js
const isLocalhost = (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]'
);

const API_BASE_URL = isLocalhost
  ? import.meta.env.VITE_SERVER_BASEURL       // Your dev server
  : import.meta.env.VITE_SH_DSERVER_BASEURL // Your live backend

export { isLocalhost, API_BASE_URL };
